var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition-group',{staticClass:"alerts",attrs:{"name":"list"},on:{"before-leave":_vm.beforeLeave}},_vm._l((_vm.alerts),function(alert,i){return _c('Alert',{key:`alert-${i}`,attrs:{"alert-type":alert.type,"alert-content":alert.content},on:{"dismissAlert":function($event){return _vm.dismissAlert(i)}}})}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }